import styled, { css } from 'styled-components';

import { MenuType } from '@r1-frontend/api-domru/api-content/v2/menu/by-types/dto/IMenuByTypesItem';

import WideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import Title from './components/Title';

import { TOP_WRAPPER_HEIGHT } from '~/src/features/_layout/Header/desktop/components/CommonDesktopHeader/styled';

const LocalCollapsedMenuBoxShadow = '4px 8px 12px rgba(0,0,0,.07)';

const getContentTypeStylesByType = (type: MenuType) => {
    switch (type) {
        case MenuType.DESCRIPTION_LABEL:
            return css`
                grid-template-rows: repeat(2, auto);
                grid-template-columns: repeat(2, auto);
                grid-auto-flow: column;
                gap: 9px 55px;
                margin-left: -18px;

                @media (max-width: ${wideBreakpoints.sDesktop}) {
                    gap: 9px 32px;
                }
            `;
        case MenuType.DESCRIPTION_BUTTON:
            return css`
                grid-template-rows: repeat(1, auto);
                grid-auto-flow: row;
                gap: 0 55px;
            `;
        case MenuType.COMMON:
        default:
            return css`
                grid-template-rows: repeat(4, auto);
                grid-auto-flow: column;
                gap: 12px 144px;
            `;
    }
};

export const CollapsedMenu = styled.div`
    position: fixed;
    left: 0;
    right: 0;
    height: 0;
    opacity: 0;
    visibility: hidden;
    overflow: hidden;
    transform-origin: top center;
    transition: height 0.3s ease;
    background-color: ${COLORS.BgMain};
    box-shadow: ${LocalCollapsedMenuBoxShadow};
`;

export const MenuItemWrapper = styled.li<{ isPromo: boolean }>`
    position: relative;
    display: flex;
    margin: 0 10px;
    padding: 8px 2px 22px;
    white-space: nowrap;
    
    &:after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 0;
        height: 2px;
        background-color: ${COLORS.Control};
        transition: width .25s;
    }

    &:hover {
        & > ${CollapsedMenu} {
            opacity: 1;
            visibility: visible;
            height: 256px;
            transition: height 0.5s;
            margin-top: ${TOP_WRAPPER_HEIGHT}px;
        }

        &:after {
            width: 100%;
        }
    }
    
    transition: color 0.3s;
    ${({ isPromo }) => isPromo
        ? css`
            color: ${COLORS.Logo};
        `
        : css`
            color: ${COLORS.TextPrimary};

            &:hover {
                color: ${COLORS.Logo};
            }
        `
    }

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        margin: 0 6px;
        padding: 10px 2px 24px;
    }
`;

export const TextItem = styled.p`
    ${FONTS.MediumXS};
    color: inherit;
    cursor: default;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.MediumXXS};
    }
`;

export const CollapsedContainer = styled(WideContainer)`
    position: relative;
    display: grid;
    grid-template-rows: 208px;
    grid-auto-flow: column;
    gap: 0 32px;
    padding-top: 24px;
    padding-bottom: 24px;
`;

export const TypeWrapper = styled.div`
    display: grid;
    grid-template-rows: auto 1fr;
    grid-template-columns: 1fr;
    grid-gap: 12px 0;
    justify-items: baseline;
`;

export const TypeTitle = styled.div`
    position: relative;
    ${FONTS.H5};
    color: ${COLORS.TextDisabled};

    &:after {
        content: ' ';
        position: absolute;
        top: 0;
        left: 0;
        ${FONTS.H5};
        user-select: none;
    }
`;

export const TypeContent = styled.div<{ type: MenuType }>`
    display: grid;
    ${p => getContentTypeStylesByType(p.type)};
    align-self: baseline;
`;

export const CommonTitle = styled(Title)<{ isCurrent: boolean }>`
    pointer-events: ${p => p.isCurrent ? 'none' : 'auto'};

    &:hover {
        div {
            color: ${COLORS.TextDisabled};
        }
    }
`;

export const LinkItem = styled.a<{ isCurrent: boolean }>`
    ${FONTS.MediumXS};
    color: inherit;
    pointer-events: ${p => p.isCurrent ? 'none' : 'auto'};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.MediumXXS};
    }
`;
